// -----------------------------------------------
// Deployment Attribute State Selectors
// -----------------------------------------------
export const getDeploymentAttributes = (
  state: State,
): DeploymentAttributesStateSlice => state.deploymentAttributes;

export const getLabels = (state: State): StateModelById<DeploymentLabel> =>
  state.deploymentAttributes.labels;

export const getMarks = (state: State): StateModelById<DeploymentMark> =>
  state.deploymentAttributes.marks;

export const getDeploymentDentition = (
  state: State,
): StateModelById<DeploymentDentition> => state.deploymentAttributes.dentition;

export const getNlisHoldings = (state: State): StateModelById<NlisHolding> =>
  state.nlisFiles.holdings.byId;

export const getIsFetchingNlisHoldings = (state: State): boolean =>
  state.nlisFiles.holdings.isFetching;

// -----------------------------------------------
// Scan Label State Selectors
// -----------------------------------------------
export const getScanLabels = (state: State) => state.scanLabels.byId;
export const getIsFetchingScanLabels = (state: State) =>
  state.scanLabels.isFetching;

// -----------------------------------------------
// Master Ledger Account State Selectors
// -----------------------------------------------
export const getMasterLedgerAccounts = (
  state: State,
): StateModelById<MasterLedgerAccount> => state.masterLedgerAccounts.byId;
